import { clientCanvasFactory } from '../../preview-canvas/snapPreview/canvasFactory/ClientCanvasFactory';
import { CanvasTextMeasurer } from 'content-creation-common/text/canvas';
import { throwError } from '../../../util/behavior';
import { error, warn } from '../../../util/log';

const getCanvasTextMeasurer = () => {
  try {
    return new CanvasTextMeasurer(clientCanvasFactory);
  } catch (err) {
    if (!self.document /* Likely in a Worker */) {
      warn('Could not create canvas text measurer');
      return null;
    } else {
      error('Could not create canvas text measurer');
      return throwError(err);
    }
  }
};
const clientCanvasTextMeasurer = getCanvasTextMeasurer();
export default clientCanvasTextMeasurer;
